import { isAccess, isAccessForAll } from "modules/common/utils";
import {
  ControlLabel,
  Wrapper,
  FormColumn,
  FormControl,
  FormGroup,
  FormWrapper,
  ButtonCommonTheme,
  ModalFormContainer,
  ModalFooter,
  ModalForm,
  Alert
} from "modules/theme";
import APIManager from "modules/common/apiManager";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Col, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { globalStateSelector } from "store/selector";
import styled, { injectGlobal } from "styled-components";
import {
  otherUser,
  superAdminAccess,
  teamleaderAccess,
  userAccess,
} from "../../../../../helpers/system-config";
import { Box, BoxName, Row, RowTitle } from "../styles/main";
import SettingDropdownMenu from "./SettingDropdownMenu";

injectGlobal`
.setting-rule {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 10px 15px;
    font-size: 20px;
    font-weight: 700;
  }
  .setting-rule span {
      margin-top: 0px;
      font-size: 16px;
      font-weight: 600;
      line-height: 36px;
      color: #010101;
      font-family: "Nunito";
    }
    .setting-rule .setting-icon {
      margin-right: 10px;
      margin-top: 0px;
      font-size: 28px;
      font-weight: 400;
      color: #010101;
      font-family: "Material Symbols Outlined";
    }
@media only screen and (max-width: 800px) {
    .for-background{
      display:none;
    }
    .boxsmall-title{
      font-size: 15px !important;
    }
    .admin-label{
      margin-top:20%;
    }
}
`;

const UserNote = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 10px;

  span {
    font-weight: 700;
    font-size: 14px;
    color: #303030;
    letter-spacing: 0.03em;
    line-height: 21px;
    margin-right: 7px;
  }

  h6 {
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0.03em;
    color: #303030;
  }
`;
class SettingTheme extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Display: "none",
      UserOptionDisplay: "none",
      UserArrow: "keyboard_double_arrow_down",
      Arrow: "keyboard_double_arrow_down",
      showModal: false,
      rule: "",
      showDataFlowModal: false,
      url: "",
      apiKey: "",
      loadingDataFlow: false,
    };
    this.mAPI = new APIManager();
    this.ruleConfig = this.ruleConfig.bind(this);
    this.dataFlowConfig = this.dataFlowConfig.bind(this);
    this.saveData = this.saveData.bind(this);
    this.saveDataFlow = this.saveDataFlow.bind(this);
  }

  componentDidMount() {
    document.title = "Settings";
  }

  renderBox(name, image, to, block, accessName) {
    const { __ } = this.context;
    const { accessDefination } = this.props;
    let access = true;

    if (
      accessDefination &&
      accessDefination[accessName] &&
      accessDefination[accessName].options
    ) {
      access = isAccess(accessDefination[accessName].options, [
        "list",
        "allow-view",
      ]);
    }

    return (
      access && (
        <Box>
          <Link
            style={block ? { cursor: "not-allowed" } : {}}
            to={!block ? to : "#"}
          >
            <span className="material-symbols-outlined setting-icon">
              {image}
            </span>
            <BoxName>{name}</BoxName>
          </Link>
        </Box>
      )
    );
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      let message = data && data.message ? data.message : "Successfully Done";
      Alert.success(message);
    } else {
      let message =
        data && data.message ? data.message : "Something wrong happened";
      Alert.error(message);
    }
  }

  saveData = (e) => {
    e.preventDefault();
    this.setState({ loading: true });

    this.mAPI.sendPostAPI(
      `setting/llm-rule`,
      {
        content: this.state.rule
      },
      (data) => {
        if (data) {
          this.setState({ showModal: false })
          Alert.success(
            (data && data.message) ||
            'Rules updated successfully'
          );
        }
      },
      (errorCode, data) => {
        this.apiResponse(errorCode, data);
      },
    );
  };

  renderModal() {
    return (
      <Modal
        show={this.state.showModal}
        className=""
        bsSize="lg"
      >
        <Modal.Header>
          <Modal.Title>Rules</Modal.Title>
          <button
            className="material-symbols-outlined bg-white border-none"
            style={{ color: "#010101", fontSize: "25px" }}
            onClick={() => {
              this.setState({
                showModal: false
              })
            }
            }
          >
            cancel
          </button>
        </Modal.Header>
        <Modal.Body style={{ paddingTop: '20px' }}>
          <ModalForm onSubmit={this.saveData}>
            <ModalFormContainer>
              <FormWrapper>
                <FormColumn>
                  <FormGroup>
                    <ControlLabel>Rule</ControlLabel>
                    <textarea
                      style={{
                        height: "258px",
                        width: "100%",
                        padding: "15px",
                        outline: "none",
                        border: "none",
                        "-webkit-transition": "all 0.3s ease",
                        transition: "all 0.3s ease",
                        "border-radius": "10px",
                        "box-shadow": "0px 3px 20px rgb(0 0 0 / 10%)",
                        color: "#010101",
                        "font-size": "14px",
                        "line-height": "19px",
                        outline: 0,
                        border: "1px solid #fff0",
                      }}
                      autofocus={false}
                      placeholder="Rule"
                      // required={true}
                      value={this.state.rule}
                      maxLength="20000"
                      id="Text"
                      // defaultValue={data.defaultValue || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        this.setState({ rule: value });
                      }}
                    >
                    </textarea>
                    <UserNote>
                      <span>NOTE: </span>
                      <h6>{` Please use the {{user_system_prompt}} variable in the rules. The application will automatically replace this variable and include the smart agent prompt. If you forget to add the rules, the smart agent prompt will not be used when calling the LLM query.`}</h6>
                    </UserNote>
                  </FormGroup>
                </FormColumn>
              </FormWrapper>
            </ModalFormContainer>
            <ModalFooter>
              <ButtonCommonTheme
                type="greyModalBtn"
                btnStyle="cancel"
                onClick={() => {
                  this.setState({
                    showModal: false
                  })
                }
                }
                size="xl"
              >
                Cancel
              </ButtonCommonTheme>
              <ButtonCommonTheme
                type="blueModalBtn"
                btnType="submit"
                btnStyle="default"
                size="xl"
                style={{ float: "right" }}
              >
                Save
              </ButtonCommonTheme>
            </ModalFooter>
          </ModalForm>
        </Modal.Body>
      </Modal>
    );
  }

  ruleConfig() {
    this.setState({ showModal: true });
    this.mAPI.sendGetAPI(
      `setting/llm-rule`,
      (data) => {
        if (data && data.data) {
          this.setState({ rule: data.data.content })
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      },
    );
  }

  saveDataFlow = (e) => {
    e.preventDefault();
    this.setState({ loadingDataFlow: true });

    this.mAPI.sendPostAPI(
      `setting/dataflow`,
      {
        url: this.state.url,
        apiKey: this.state.apiKey
      },
      (data) => {
        if (data) {
          this.setState({ showDataFlowModal: false })
          this.setState({ loadingDataFlow: false });
          Alert.success(
            (data && data.message) ||
            'Data Flow Added Successfully.'
          );
        }
      },
      (errorCode, data) => {
        this.setState({ loadingDataFlow: false });
        this.apiResponse(errorCode, data);
      },
    );
  };

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  renderDataFlowModal() {
    return (
      <Modal
        show={this.state.showDataFlowModal}
        className=""
        bsSize="md"
      >
        <Modal.Header>
          <Modal.Title>Data Flow Configuration</Modal.Title>
          <button
            className="material-symbols-outlined bg-white border-none"
            style={{ color: "#010101", fontSize: "25px" }}
            onClick={() => {
              this.setState({
                showDataFlowModal: false,
                url: '',
                apiKey: ''
              })
            }
            }
          >
            cancel
          </button>
        </Modal.Header>
        <Modal.Body>
          <ModalForm onSubmit={this.saveDataFlow}>
            <ModalFormContainer>
              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup("Url", {
                    defaultValue: "",
                    placeholder: "Url",
                    maxLength: 200,
                    autoFocus: true,
                    disabled: this.state.disabled,
                    required: true,
                    id: "url",
                    value: this.state.url,
                    onChange: (e) => {
                      if (e.target.value == " ") {
                        return false;
                      }
                      this.setState({ url: e.target.value });
                    },
                  })}
                </FormColumn>
              </FormWrapper>
              <FormWrapper>
                <FormColumn>
                  {this.renderFormGroup("API Key", {
                    defaultValue: "",
                    placeholder: "Api Key",
                    maxLength: 300,
                    autoFocus: false,
                    disabled: this.state.disabled,
                    required: true,
                    id: "apiKey",
                    value: this.state.apiKey,
                    onChange: (e) => {
                      if (e.target.value == " ") {
                        return false;
                      }
                      this.setState({ apiKey: e.target.value });
                    },
                  })}
                </FormColumn>
              </FormWrapper>
            </ModalFormContainer>
            <ModalFooter>
              <ButtonCommonTheme
                type="greyModalBtn"
                btnStyle="cancel"
                onClick={() => {
                  this.setState({
                    showDataFlowModal: false,
                    url: "",
                    apiKey: ""
                  })
                }
                }
                size="xl"
              >
                Cancel
              </ButtonCommonTheme>
              <ButtonCommonTheme
                type="blueModalBtn"
                btnType="submit"
                btnStyle="default"
                isLoading={this.state.loadingDataFlow}
                size="xl"
                style={{ float: "right" }}
              >
                Save
              </ButtonCommonTheme>
            </ModalFooter>
          </ModalForm>
        </Modal.Body>
      </Modal>
    );
  }

  dataFlowConfig() {
    this.setState({ showDataFlowModal: true });
    this.mAPI.sendGetAPI(
      `setting/dataflow`,
      (data) => {
        if (data) {
          this.setState({ url: data.url, apiKey: data.apiKey })
        }
      },
      (error, data) => {
        if (data) {
          Alert.error(` ${data.message}`);
        } else {
          Alert.error(`${error}`);
        }
      },
    );
  }

  render() {
    const { __ } = this.context;
    let { currentUser, origanisation } = this.props;
    const breadcrumb = [
      { title: __("Settings"), link: "/settings" },
    ];

    let displayProvider =
      origanisation && origanisation.displayProvider
        ? origanisation.displayProvider
        : false;
    const content = (
      <div>
        {isAccessForAll(this.props.accessDefination, [
          "user",
          "skill",
          //'permission',
        ]) && (
            <Row className="rowBox">
              <Col sm={12}>
                <RowTitle className="secondRow boxsmall-title">
                  {__("Users and Permissions")}
                </RowTitle>
                <div className="d-flex w-100">
                  <div>
                    {this.renderBox(
                      __("Users"),
                      "person",
                      "/settings/User",
                      false,
                      "user"
                    )}
                    {this.renderBox(
                      __("Skills"),
                      "design_services",
                      "/settings/Skills",
                      false,
                      "skill"
                    )}
                    {/*
									{userAccess.includes(currentUser.role) &&
										this.renderBox(
											__('Permissions'),
											'admin_panel_settings',
											'/settings/Permissions',
											false,
											'permission'
										)}
                                            */}
                  </div>
                </div>
              </Col>
            </Row>
          )}
        {isAccessForAll(this.props.accessDefination, [
          "provider",
          "phone-number",
          "integration",
          "missed-call-to-campaign",
        ]) &&
          (!teamleaderAccess.includes(currentUser.role) ||
            superAdminAccess.includes(currentUser.role) ||
            userAccess.includes(currentUser.role)) && (
            <Row className="rowBox">
              <Col sm={12}>
                {!teamleaderAccess.includes(currentUser.role) && (
                  <RowTitle className="secondRow  boxsmall-title">
                    {__("Communication Channels")}
                  </RowTitle>
                )}
                {!teamleaderAccess.includes(currentUser.role) && (
                  <div className="d-flex w-100">
                    <div>
                      {(displayProvider ||
                        superAdminAccess.includes(currentUser.role)) &&
                        this.renderBox(
                          __(`Providers`),
                          "cell_tower",
                          "/settings/providers",
                          false,
                          "provider"
                        )}
                      {userAccess.includes(currentUser.role) &&
                        this.renderBox(
                          __("Phone Numbers"),
                          "phone_in_talk",
                          "/settings/Phonenumbers",
                          false,
                          "phone-number"
                        )}
                      {this.renderBox(
                        __("Integrations"),
                        "settings_ethernet",
                        "/settings/integrations",
                        false,
                        "integration"
                      )}

                      {this.renderBox(
                        __("Missed Call To Campaign"),
                        "phone_missed",
                        "/settings/missed-call-to-campaign",
                        false,
                        "missed-call-to-campaign"
                      )}
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          )}
        {isAccessForAll(this.props.accessDefination, [
          "disposition",
          "contact",
          "sound",
          "break",
          "dnc",
          "holiday",
          "flow",
          "knowledge-base",
          "import-export",
          "logs",
        ]) && (
            <Row className="rowBox">
              <Col sm={12}>
                <RowTitle className="secondRow boxsmall-title">
                  {__("General Settings")}
                </RowTitle>
                <div className="d-flex w-100">
                  <div>
                    {this.renderBox(
                      __("Disposition"),
                      "workspace_premium",
                      "/settings/dispose",
                      false,
                      "disposition"
                    )}
                    {this.renderBox(
                      __("Contacts"),
                      "contacts",
                      "/settings/Contact-List",
                      false,
                      "contact"
                    )}
                    {this.renderBox(
                      __("Sounds"),
                      "volume_up",
                      "/settings/sounds",
                      false,
                      "sound"
                    )}
                    {this.renderBox(
                      __("Break"),
                      "dinner_dining",
                      "/settings/Break",
                      false,
                      "break"
                    )}
                    {this.renderBox(
                      __("DNC"),
                      "phone_disabled",
                      "/settings/DNC",
                      false,
                      "dnc"
                    )}
                    {this.renderBox(
                      __("Inbound Block"),
                      "block",
                      "/settings/inbound-block",
                      false,
                      "inbound-block"
                    )}
                    {this.renderBox(
                      __("Holiday"),
                      "sailing",
                      "/settings/Holiday-group",
                      false,
                      "holiday"
                    )}
                    {/* {this.renderBox(
                  __("CSAT"),
                  "auto_awesome",
                  "/settings/CSAT",
                  true
                )} */}
                    {/* {this.renderBox(__("Country"), "public", "/settings/Country")} */}
                    {userAccess.includes(currentUser.role) &&
                      this.renderBox(
                        __("Flow"),
                        "account_tree",
                        "/settings/flow",
                        false,
                        "flow"
                      )}
                    {!teamleaderAccess.includes(currentUser.role) && this.renderBox(
                      __("Knowledge Base"),
                      "cognition_2",
                      "/settings/knowledge-base",
                      false,
                      "knowledge-base"
                    )}
                    {this.renderBox(
                      __("Import & Export"),
                      "published_with_changes",
                      "/settings/import-export",
                      false,
                      "import-export"
                    )}
                    {!teamleaderAccess.includes(currentUser.role) &&
                      this.renderBox(
                        __("Logs"),
                        "description",
                        "/settings/logs",
                        false,
                        "logs"
                      )}
                    {userAccess.includes(currentUser.role) &&
                      this.renderBox(
                        __("Guardrails"),
                        "verified_user",
                        "/settings/guardrails",
                        false,
                        "guardrails"
                      )}
                    {userAccess.includes(currentUser.role) &&
                      this.renderBox(
                        __("Help Center"),
                        "help_center",
                        "/settings/help-center",
                        false,
                        "help-center"
                      )}
                    {superAdminAccess.includes(currentUser.role) &&
                      <Box onClick={this.ruleConfig}>
                        <div className="setting-rule">
                          <span className="material-symbols-outlined setting-icon">
                            rule_settings
                          </span>
                          <BoxName>Rules</BoxName>
                        </div>
                      </Box>
                    }
                    {superAdminAccess.includes(currentUser.role) &&
                      <Box onClick={this.dataFlowConfig}>
                        <div className="setting-rule">
                          <span className="material-symbols-outlined setting-icon">
                            flowchart
                          </span>
                          <BoxName>Data Flow</BoxName>
                        </div>
                      </Box>
                    }
                  </div>

                </div>
              </Col>
            </Row>
          )}
        {(userAccess.includes(currentUser.role) ||
          otherUser.includes(currentUser.role)) && (
            <Row className="rowBox">
              <Col sm={12}>
                <RowTitle className="secondRow boxsmall-title">
                  {__("Messages")}
                </RowTitle>
                <div className="d-flex w-100">
                  {(userAccess.includes(currentUser.role) ||
                    otherUser.includes(currentUser.role)) &&
                    this.renderBox(
                      __("Canned Messages"),
                      "upcoming",
                      "/settings/canned-messages",
                      false,
                      "message"
                    )}
                </div>
              </Col>
            </Row>
          )}
        {/* {(userAccess.includes(currentUser.role) ||
          otherUser.includes(currentUser.role)) && (
          <Row className="rowBox">
            <Col sm={12}>
              <RowTitle className="secondRow boxsmall-title">
                {__("Security and Crediantials")}
              </RowTitle>
              <div className="d-flex w-100">
                <div>
                  {(userAccess.includes(currentUser.role) ||
                    otherUser.includes(currentUser.role)) &&
                    this.renderBox(
                      __("Voice Provider"),
                      "graphic_eq",
                      "/settings/voice-provider",
                      false,
                      "voice-provider"
                    )}
                  {(userAccess.includes(currentUser.role) ||
                    otherUser.includes(currentUser.role)) &&
                    this.renderBox(
                      __("Model Provider"),
                      "upcoming",
                      "/settings/model-provider",
                      false,
                      "model-provider"
                    )}
                  {(userAccess.includes(currentUser.role) ||
                    otherUser.includes(currentUser.role)) &&
                    this.renderBox(
                      __("Transcriber Provider"),
                      "upcoming",
                      "/settings/transcriber-provider",
                      false,
                      "transcriber-provider"
                    )}
                </div>
              </div>
            </Col>
          </Row>
        )} */}

        {isAccessForAll(this.props.accessDefination, [""]) && (
          superAdminAccess.includes(currentUser.role) && (
            <Row className="rowBox">
              <Col sm={12}>
                <RowTitle className="secondRow boxsmall-title">
                  {__("TTS Billing")}
                </RowTitle>
                <div className="d-flex w-100">
                  {superAdminAccess.includes(currentUser.role) &&
                    this.renderBox(
                      __('Provider'),
                      'public',
                      '/settings/tts-provider-billing',
                      false,
                      'tts-provider-billing'
                    )}
                  {/* {superAdminAccess.includes(currentUser.role) &&
                    this.renderBox(
                      __('Model'),
                      'public',
                      '/settings/tts-billing-model',
                      false,
                      'tts-billing-model'
                    )} */}
                </div>
              </Col>
            </Row>
          )
        )}


        {isAccessForAll(this.props.accessDefination, ["account"]) &&
          (userAccess.includes(currentUser.role) ||
            otherUser.includes(currentUser.role)) && (
            <Row className="rowBox">
              <Col sm={12}>
                <RowTitle className="secondRow boxsmall-title">
                  {__("Account Settings")}
                </RowTitle>
                <div className="d-flex w-100">
                  {(userAccess.includes(currentUser.role) ||
                    otherUser.includes(currentUser.role)) &&
                    this.renderBox(
                      __("Account"),
                      "settings_applications",
                      "/settings/account-setting",
                      false,
                      "account"
                    )}
                  {/* {superAdminAccess.includes(currentUser.role) &&
									this.renderBox(
										__('Region'),
										'public',
										'/settings/region',
										false,
										'region'
									)} */}
                </div>
              </Col>
            </Row>
          )}


        {/* {isAccessForAll(this.props.accessDefination, ['account']) &&  */}
        {/* } */}
      </div>
    );

    return (
      <span>
        <Wrapper
          showLeftSideBar={true}
          leftSidebar={<SettingDropdownMenu />}
          header={<Wrapper.Header breadcrumb={breadcrumb} />}
          heading={<ControlLabel>{`Settings`}</ControlLabel>}
          actionBar={false}
          content={content}
          transparent={false}
        />
        {this.renderModal()}
        {this.renderDataFlowModal()}
      </span>
    );
  }
}

SettingTheme.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  currentUser: globalStateSelector.getDynamic(state, { key: "currentUser" }),
  origanisation: globalStateSelector.getDynamic(state, {
    key: "origanisation",
  }),
  accessDefination: globalStateSelector.getDynamic(state, {
    key: "accessDefination",
  }),
});

export default connect(stateToProps)(SettingTheme);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/SettingTheme.js